import { render, staticRenderFns } from "./podcastEpsCard.vue?vue&type=template&id=21c59d7c&scoped=true&"
import script from "./podcastEpsCard.vue?vue&type=script&lang=js&"
export * from "./podcastEpsCard.vue?vue&type=script&lang=js&"
import style0 from "./podcastEpsCard.vue?vue&type=style&index=0&id=21c59d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c59d7c",
  null
  
)

export default component.exports